import { render, staticRenderFns } from "./TenantUsers.vue?vue&type=template&id=2166dee6&"
import script from "./TenantUsers.vue?vue&type=script&lang=js&"
export * from "./TenantUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports